import { TrackEnum } from 'constants/EnumTracking';

import Tracking from 'services/Tracking';

type TTrackEnum = keyof typeof TrackEnum;

type TOpenLinkPaymentParams = {
  budgetId: string;
  message?: string;
};

type TTracking = {
  trackAction: (
    actionId: TTrackEnum,
    budgetId: string,
    actionMessage?: string,
  ) => void;
  openLinkPayment: (params: TOpenLinkPaymentParams) => void;
};

export const useTracking = (): TTracking => {
  const trackAction = (
    actionId: TTrackEnum,
    budgetId: string,
    actionMessage?: string,
  ) => {
    Tracking.trackAction(actionId, budgetId, actionMessage);
  };

  const openLinkPayment = ({ budgetId, message }: TOpenLinkPaymentParams) => {
    Tracking.trackAction(TrackEnum.AberturaLink, budgetId, message);
  };

  return {
    trackAction,
    openLinkPayment,
  };
};
